import { CHART_COLORS } from '@silverfort-nodelibs/common/utils/consts';

export const COLOR_BY_PROTOCOL = {
    kerberos: CHART_COLORS[0],
    ntlm: CHART_COLORS[1],
    ldap: CHART_COLORS[2],
    ldaps: CHART_COLORS[3],
    oidc: CHART_COLORS[4],
    radius: CHART_COLORS[5],
    saml: CHART_COLORS[6],
    api: CHART_COLORS[7],
    'aad sso': CHART_COLORS[8],
    'octa sso': CHART_COLORS[9],
    ping_adapter: CHART_COLORS[10],
    adfs: CHART_COLORS[11],
    desktop: CHART_COLORS[12]
};
